import { render, staticRenderFns } from "./ScaDetail.vue?vue&type=template&id=3b1a3d3e&scoped=true&"
import script from "./ScaDetail.vue?vue&type=script&lang=ts&"
export * from "./ScaDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ScaDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ScaDetail.vue?vue&type=style&index=1&id=3b1a3d3e&scoped=true&lang=scss&"
import style2 from "./ScaDetail.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a3d3e",
  null
  
)

export default component.exports